import React, { useEffect, useState } from "react";
import CustomDataGrid from "../../../../../../components/common/CustomDataGrid";
import { loanColumns } from "../../../../../../constants/columns/financialColumns";
import { adminApi } from "../../../../../../services";
import { Link } from "react-router-dom";

export default function Loans() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLoans = async () => {
    try {
      const res = await adminApi.getAllLoans();
      setData(res?.data?.data);
    } catch {
      alert("Failed to fetch loans");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLoans();
  }, []);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between mb-3">
        <h2>Loans</h2>
        <Link to="/admin-dashboard/loans/create">
          <button className="btn btn-primary">+ Create Loan</button>
        </Link>
      </div>

      <CustomDataGrid
        rows={data}
        columns={loanColumns}
        loading={loading}
        getRowId={(row) => row._id}
      />
    </div>
  );
}
